<dx-popup
    #popupFormRelation
    [width]="isPhone ? isPhoneLandscape ? '90vw' : '100%' : 680"
    [height]="isPhone ? 'auto' : 480"
    [showTitle]="true"
    [title]="title"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [(visible)]="popupVisible"
    (onShowing)="onShowing()"
    (onShown)="selectRows($event)"
    [maxHeight]="'80vh'"
>
    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="submitSelection()"></dx-button>
    </dxi-toolbar-item>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div *dxTemplate="let data of 'content'" style="top: -150px !important;">
            <dx-data-grid style="margin: 4px; min-width: 250px!important;"
                #formRelation
                          [keyExpr]="keyExpr"
                [dataSource]="currentDataSource"
                [height]="'100%'"
                [showRowLines]="true"
                [showBorders]="true"
                [highlightChanges]="true"
                [columns]="columns"
                [showColumnLines]="true"
                [hoverStateEnabled]="true"
                [wordWrapEnabled]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                          [selection]="{ mode: 'multiple', selectAllMode: 'page' }"
                [columnHidingEnabled]="isPhone"
                (onSelectionChanged)="selectionChanged($event)">
                <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
                <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
            </dx-data-grid>
        </div>
    </div>
</dx-popup>
